/**
 * This file contains common functions used to render specific columns in the ListView.
 */

import React from 'react';

import DisplayNumber from '@commons/DisplayNumber';

/**
 * The value is stored as a number between 0 and 1, and we display it as a percentage
 */
export const renderTargetProductionWasteRate = (item) => {
  if (item == null) {
    return '-';
  }

  return <DisplayNumber number={item * 100} />;
};
